import { OptionDetail } from '../../types/OptionChainType';

export const filterByExpirationAfter = (compareDate: Date) => (option: OptionDetail): boolean => {
    const expirationDate = new Date(option.details.expiration_date);
    return expirationDate > compareDate;
};